import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  state: {
    isToken: localStorage.getItem("isToken") || null,
    pathTemporal: null,
    isTestUser: false,
    loginHelper: null,
  },
  mutations,
  actions,
  getters,
};
